import { WorkoutCard as BaseWorkoutCard } from './workout-card'
import { WorkoutCardCompletedBadge } from './workout-card-completed-badge'
import { WorkoutCardContent } from './workout-card-content'
import { WorkoutCardCoreCharge } from './workout-card-core-charge'
import { WorkoutCardDuration } from './workout-card-duration'
import { WorkoutCardFavorites } from './workout-card-favorites'
import { WorkoutCardFlexFlow } from './workout-card-flex-flow'
import { WorkoutCardImage } from './workout-card-image'
import { WorkoutCardList } from './workout-card-list'
import { WorkoutCardMeta } from './workout-card-meta'
import { WorkoutCardOverlay } from './workout-card-overlay'
import { WorkoutCardTitle } from './workout-card-title'
import { WorkoutCardTrainer } from './workout-card-trainer'
import { WorkoutCardTrending } from './workout-card-trending'
import type { Workout } from '../../../dao/core-dao'
import type { ComponentType, ReactNode } from 'react'

// Compose compound components
const WorkoutCard = BaseWorkoutCard as typeof BaseWorkoutCard & {
  Image: ComponentType<{ children?: ReactNode; className?: string }>
  Overlay: ComponentType<{ children: ReactNode; className?: string }>
  Content: ComponentType<{ children: ReactNode; className?: string; padding?: number }>
  CompletedBadge: ComponentType
  Title: ComponentType<{ className?: string }>
  Meta: ComponentType<{ className?: string }>
  Trainer: ComponentType<{ className?: string; source?: 'lookup' | 'payload' }>
  Duration: ComponentType
  FlexFlow: ComponentType<{ workout: Workout; isCompleted?: boolean; className?: string; onAction: () => void }>
  CoreCharge: ComponentType<{ workout: Workout; isCompleted?: boolean; className?: string; onAction: () => void }>
  List: ComponentType<{ workout: Workout; isCompleted?: boolean; className?: string; onAction: () => void }>
  Trending: ComponentType<{ workout: Workout; isCompleted?: boolean; className?: string; onAction: () => void }>
  Favorites: ComponentType<{ workout: Workout; className?: string; onAction: () => void }>
}

WorkoutCard.Image = WorkoutCardImage
WorkoutCard.Overlay = WorkoutCardOverlay
WorkoutCard.Content = WorkoutCardContent
WorkoutCard.CompletedBadge = WorkoutCardCompletedBadge
WorkoutCard.Title = WorkoutCardTitle
WorkoutCard.Meta = WorkoutCardMeta
WorkoutCard.Trainer = WorkoutCardTrainer
WorkoutCard.Duration = WorkoutCardDuration

// Attach preset compositions
WorkoutCard.FlexFlow = WorkoutCardFlexFlow
WorkoutCard.CoreCharge = WorkoutCardCoreCharge
WorkoutCard.List = WorkoutCardList
WorkoutCard.Trending = WorkoutCardTrending
WorkoutCard.Favorites = WorkoutCardFavorites

export { WorkoutCard }
export type { Workout } from 'src/dao/core-dao'
